module.exports = __webpack_public_path__ + "img/Logo_white.789c2129.png";